import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  user: {},
  error: "", // for error message
  loading: false,
  isUserLogout: false,
  errorMsg: false, // for error
  refreshTokenError: null,
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    apiError(state, action) {
      state.error = action.payload;
      state.loading = true;
      state.isUserLogout = false;
      state.errorMsg = true;
    },
    loginSuccess(state, action) {
      state.user = action.payload
      state.loading = false;
      state.errorMsg = false;
    },
    refreshTokenSuccess(state, action) {
      state.user = action.payload;
      state.loading = false;
      state.errorMsg = false;
      state.refreshTokenError = null;
    },
    refreshTokenError(state, action) {
      state.refreshTokenError = action.payload;
    },
    logoutUserSuccess(state, action) {
      state.isUserLogout = true
    },
    logoutUserRequest(state) {
      state.loading = true;
    },
    logoutUserFail(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    reset_login_flag(state) {
      state.error = null
      state.loading = false;
      state.errorMsg = false;
    }
  },
});

export const {
  apiError,
  loginSuccess,
  refreshTokenSuccess,
  refreshTokenError,
  logoutUserSuccess,
  logoutUserRequest,
  logoutUserFail,
  reset_login_flag
} = loginSlice.actions

export default loginSlice.reducer;